export const zapisnik_o_predaji= {
    templateId: 80,
    category: 8,
    templateTitle: 'Zapisnik pri predaji instrumenta osiguranja plaćanja',
    templateDescription: `<p>Kako bi se adekvatno pratilo navedeno osjetljivo područje, primopredaja instrumenta osiguranja plaćanja obavlja se zapisnički.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Zapisnik o predaji odnosno potpisivanje zapisnika pri predaji sredstava osiguranja plaćanja predstavlja dobru praksu u poslovanju.</p>
    <p>Predajom sredstava osiguranja plaćanja uz zapisnik stvaraju se preduvjeti za praćenje i ustroj evidencije predanih, a time i vraćenih sredstava osiguranja plaćanja.</p> 
    <p>Navedeno područje važno je pratiti jer predaja sredstava osiguranja uz zapisnik i praćenja predanih/vraćenih sredstava osiguranja smanjuje rizik od manipulacija te naknadnog neovlaštenog korištenja sredstava osiguranja od strane primatelja ili trećih osoba.</p>

    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Neovjeravanje mjeničnog očitovanja kod javnog bilježnika - za bjanko mjenice</strong></p>
    <p>Pojašnjenje: bjanko mjenica nije mjenica već papir koji će tek postati mjenica ako i kad bude ispunjena u skladu sa zakonom. Bjanko mjenica nije mjenica jer ne sadrži sve sastojke mjenice, a ista nije niti pojmovno propisana zakonom, no i dalje ima značaj u poslovanju. Kod izdavanja bjanko mjenice izdavatelj, odnosno trasant, mora ovlastiti imatelja bjanko mjenice
    da ispuni potrebni sadržaj mjenice te će nakon ispunjavanja mjenica imati sve značajke mjenice. Navedeno ovlaštenje daje se putem mjeničnog očitovanja koje je nužno s obzirom na navedeno, pri čemu je potpis izdavatelja na mjeničnom očitovanju potrebno ovjeriti kod javnog bilježnika. </p>

    `,
    
    sides: [
        {
            signature: 'Za Predavatelja:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
          ],
            suffix: ' (u daljnjem tekstu: Predavatelj)',
            delimiter: `i`
        },
        {
            signature: 'Za Preuzimatelja:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
        ],
            suffix: ' (u daljnjem tekstu: Preuzimatelj),'
        }
    ],

    headline: "potpisuju sljedeći",
    title: 'ZAPISNIK O PRIMOPREDAJI INSTRUMENTA OSIGURANJA PLAĆANJA',
    noArticleNumbers: true,
    noArticleTitle: true,

    articles: [
      {
        title: '',
        mandatory: true,
        dummy: true,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'Ovim zapisnikom Predavatelj vrši predaju, a Preuzimatelj preuzima instrument osiguranja plaćanja naveden u ovom Zapisniku.',
                value: '',
            },
        ],
        value: '',
    },
     
        {
            title: "",
            mandatory: false,
            dummy: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  { type: "text", content: "Vrsta i naziv instrumenta osiguranja plaćanja:" },
                  { type: "textarea",  value: "",required: true, help: "Ovdje upisujete vrstu i naziv instrumenta osiguranja plaćanja - npr. bjanko zadužnice na iznos do 50.000,00, vlastitu bjanko akceptiranu mjenicu po viđenju s naznakom „bez protesta“ (broj mjenice: 12604927, SERIJA A) sl.." },  
                ],
              }
            ]
          },
          {
            title: "",
            mandatory: false,
            dummy: true,
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "Instrument osiguranja plaćanja izdan je na iznos" },
                          { type: "input", value: "", required: true },
                          { help: "Upišite iznos na koji je izdan instrument osiguranja plaćanja." },  
                        ]
                      },
                {
                    parts: [
                      { type: "text", content: "Instrument osiguranja plaćanja (mjenica) je izdan bjanko - bez iznosa." },
                      { help: "Samo mjenice mogu biti izdane bez unosa ikakvog iznosa na koji instrument osiguranja plaćanja glasi.", required: true },
                    ]
                  },
                
                ],
              }
            ]
          },
          {
            title: "",
            mandatory: false,
            dummy: true,
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "Izdavatelj instrumenta osiguranja plaćanja je gore navedeni Predavatelj sredstva osiguranja." },
                        ]
                      },
                {
                    parts: [
                      { type: "text", content: "Izdavatelj instrumenta osiguranja plaćanja je" },
                      { type: "input", value: "", required: true,  placeholder: "Naziv izdavatelja" },
                      { type: "text", content: "," },
                      { type: "text", content: "iz" },
                      { type: "input", value: "", required: true,  placeholder: "Mjesto",},
                      { type: "text", content: "," },
                      { type: 'text', content: 'OIB:' },
                      { type: "input",  required: true,},
                      { type: "text", content: "." },  
                    ]
                  },
                ],
              }
            ]
          },
          {
            title: "",
            mandatory: false,
            dummy: true,
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "U instrumentu osiguranja plaćanja nije naveden jamac/jamac platac." },
                        ]
                      },
                {
                    parts: [
                      { type: "text", content: "Jamac/jamac platac instrumenta osiguranja plaćanja je:" },
                      { type: "input", value: "", required: true,  placeholder: "Naziv jamca/jamca platca" },
                      { type: "text", content: "," },
                      { type: "text", content: "iz" },
                      { type: "input", value: "", required: true,  placeholder: "Mjesto",},
                      { type: "text", content: "," },
                      { type: 'text', content: 'OIB:' },
                      { type: "input",  required: true,},
                      { type: "text", content: "." },  
                    ]
                  },
                ],
              }
            ]
          },
          {
            title: '',
            mandatory: false,
            dummy: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Broj ovjere instrumenta osiguranja plaćanja/mjeničnog očitovanja'},
                        {type: 'input', value: '', required: true, help: 'Ukoliko je izdana zadužnica/bjanko zadužnica, upisujete broj ovjere na navedenim dokumentima, a ukoliko je izdana bjanko mjenica (mjenica u kojoj vjerovnik sam upisuje potrebne podatke koji se odnose na svotu, dospijeće i sl.) upisujete broj ovjere mjeničnog očitovanja.'},
                        {type: 'text', content: '​,'},
                        {type: 'text', content: 'ovjeren pri javnom bilježniku'},
                        {type: 'input', value: '', required: true,},
                        {type: 'text', content: '​,'},
                        {type: 'text', content: 'dana'},
                        {type: 'input', value: '', required: true,},
                        {type: 'text', content: 'godine.'},
                      ],
                }],
        },
      {
        title: "",
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              { type: "text", content: "Svrha odnosno pravna osnova izdavanja instrumenta osiguranja plaćanja je" },
              { type: "textarea",  value: "",required: true, help: "Ovdje upisujete osnovu tražbine koja se osigurava izdavanjem instrumenta osiguranja plaćanja." },  
            ],
          }
        ]
      },
      {
        title: '',
        mandatory: false,
        dummy: true,
        statements: [
            {
                type: 'input',
                mandatory: true,
                editable: false,
                parts: [
                    {
                        type: 'text',
                        content: 'Primopredaja (predaja) instrumenta osiguranja plaćanja izvršena je u'
                    },
                    {
                        type: 'input',
                        value: '',
                        placeholder: "Upišite mjesto.",
                        required: true
                    },
                    {
                        type: 'text',
                        content: ', dana'
                    },
                    {
                      type: 'input',
                      value: '',
                      placeholder: "Upišite datum.",
                      required: true
                  },
                    {
                        type: 'text',
                        content: 'godine.'
                    }
                ]
            },
        ]
    },
          
              {
                title: '',
                mandatory: false,
                dummy: true,
                statements: [
                    {
                        type: 'text',
                        required: false,
                        mandatory: true,
                        editable: true,
                        content: 'Ovaj Zapisnik sastavljen je u 2 (dva) primjerka, od kojih svaka strana zadržava po 1 (jedan) primjerak.',
                        value: '',
                    }],
              },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/80_zapisnik_o_predaji.ts